import React from 'react';
import { useSpring, animated } from '@react-spring/web';

function sendNow(e){
  e.preventDefault();
  alert("This services currently unavailable");
}

export default function SendEmail() {
  let props = useSpring({ to: { opacity: 1,marginTop:0 }, from: { opacity: 0,marginTop:-100 } })
  return (
    <>
     <p className="expire">Send Via Email</p>
      
      <animated.form style={props} className="email-form">
        
        <div className="first-field">
          <label htmlFor="your-email">Your Email :</label>
          <input type="text" name="your" required id="your-email" />
        </div>
        
        <div className="second-field">
          <label htmlFor="from-email">Send TO :&nbsp; &nbsp;</label>
          <input type="text" name="from" required id="from-email" />
        </div>
        <div className="btn">
          <button onClick={sendNow}>Send Now</button>
        </div>

      </animated.form>
    </>
  )
}



